import { type UseQueryResult, useQuery } from 'react-query';
import { StatusDropdownAppServicesService } from '@wealthlane/api-services/wealthlane-award-service';

const useGetCancelShareTypes = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const cancelShareTypes = useQuery(
    ['getCancelShareTypes'],
    async () => {
      return await handleRequest(
        StatusDropdownAppServicesService.getApiAwardApiAppStatusDropdownAppServicesCancelShareTypes()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.text ?? '',
            value: item.value ?? '',
          };
        });
      },
    }
  );

  return cancelShareTypes;
};

export default useGetCancelShareTypes;
